const AMBIENTE = 'https://server.basedefutbol.com/baseunica';
export default AMBIENTE;
